export * as antd from 'antd'
